import * as color from '@constant/color';

// export const IS_PROBLEM_SERVICE = process.env.NODE_ENV === 'development';
export const IS_PROBLEM_SERVICE = false;
export const IS_DEVELOPMENT = process.env.NODE_ENV === 'development';
// 듣기 빈칸문제 UI 출시 여부. 백엔드 연동 전까지 로컬 개발 환경에서만 노출한다.
export const IS_LISTENING_RELEASE = IS_DEVELOPMENT;
// App Store / Play Store 스크린샷 촬영용 데모 화면을 활성화한다.
export const IS_DEMO = false;
export const DEMO_AUTHENTIC_EXPRESSION_KEY = 'qzxpv7m0actr1bgy';
export const DEMO_ENGLISH_MINI_STORY_KEY = 'cgvv32hg1aumkmid';
export const DEMO_JAPANESE_MINI_STORY_KEY = 'cq4fezwybysqueqs';

/**
 * 빈칸 영역을 표시하기 위한 마커.
 * `[answer]` → `###answer###` 형태로 변환해 TextBlock에 넘기면, TextBlock이 마커 토큰을 빈칸 박스로 렌더한다.
 */
export const BLANK_MARKER = '###';

export const MS_BEGIN_MENUS = [
  // {
  //   menu: 'subscription-all',
  //   text: '많이 읽은 글',
  //   icon: { icon: 'star', size: 'medium', kind: 'filled', color: color.WHITE_1 },
  // },
  {
    type: 'begin',
    menu: 'begin-today',
    text: '오늘의소식',
    icon: { icon: 'today', size: 'medium', kind: 'outlined', color: color.WHITE_1 },
  },
  {
    type: 'begin',
    menu: 'begin-find',
    text: '찾아보기',
    icon: { icon: 'search', size: 'medium', kind: 'outlined', color: color.WHITE_1 },
  },
  {
    type: 'begin',
    menu: 'begin-tip',
    text: '도움말',
    icon: { icon: 'help', size: 'medium', kind: 'outlined', color: color.WHITE_1 },
  },
];

export const MS_SHELF_MENUS = [
  {
    type: 'shelf',
    menu: 'shelf-all',
    text: '전체보기',
    icon: { icon: 'mail', size: 'medium', kind: 'outlined', color: color.WHITE_1 },
  },
  {
    type: 'shelf',
    menu: 'shelf-unread',
    text: '안읽음',
    icon: { icon: 'mail-unread', size: 'medium', kind: 'outlined', color: color.WHITE_1 },
  },
  // {
  //   type: 'shelf',
  //   menu: 'shelf-archive',
  //   text: '정리함',
  //   icon: { icon: 'hash', size: 'medium', kind: 'filled', color: color.WHITE_1 },
  // },
  {
    type: 'shelf',
    menu: 'shelf-bookmark',
    text: '즐겨찾기',
    icon: { icon: 'star', size: 'medium', kind: 'filled', color: color.WHITE_1 },
  },
  {
    type: 'shelf',
    menu: 'shelf-trash',
    text: '휴지통',
    icon: { icon: 'trash', size: 'medium', kind: 'outlined', color: color.WHITE_1 },
  },
];

export const SUBSCRIPTION_MENUS = [
  {
    type: 'subscription',
    menu: 'subscription-all',
    text: '전체보기',
    icon: { icon: 'menu', size: 'medium', kind: 'outlined', color: color.WHITE_1 },
  },
  // {
  //   menu: 'subscription-bookmark',
  //   text: '즐겨찾기',
  //   icon: { icon: 'star', size: 'medium', kind: 'filled', color: color.WHITE_1 },
  // },
  {
    type: 'subscription',
    menu: 'subscription-trash',
    text: '구독해제',
    icon: { icon: 'trash', size: 'medium', kind: 'outlined', color: color.WHITE_1 },
  },
];

export const STUDY_LANGUAGE_OPTIONS = [
  { key: 'english', label: '🇺🇸', content: '영어', value: '영어' },
  { key: 'japanese', label: '🇯🇵', content: '일본어', value: '일본어' },
] as const;

export const VOCABULARY_COUNT_OPTIONS = [
  { key: 'a', label: '가볍게', content: '10개', value: 10 },
  { key: 'b', label: '알차게', content: '20개', value: 20 },
  { key: 'c', label: '열심히', content: '50개', value: 50 },
] as const;

export const GRAMMAR_COUNT_OPTIONS = [
  { key: 'a', label: '가볍게', content: '5개', value: 5 },
  { key: 'b', label: '알차게', content: '10개', value: 10 },
  { key: 'c', label: '열심히', content: '20개', value: 20 },
] as const;

export const TEST_COUNT_OPTIONS = [
  { key: 'a', label: '가볍게', content: '1회', value: 1 },
  { key: 'b', label: '알차게', content: '2회', value: 2 },
  { key: 'c', label: '열심히', content: '5회', value: 5 },
] as const;

export const VOCABULARY_LEVEL_OPTIONS = [
  { key: 'a', label: '쉽게', content: '쉬운 어휘', value: 'EASY' },
  { key: 'b', label: '보통', content: '일반적인 어휘', value: 'NORMAL' },
  { key: 'c', label: '어렵게', content: '어려운 어휘', value: 'HARD' },
] as const;

export const GRAMMAR_LEVEL_OPTIONS = [
  { key: 'a', label: '쉽게', content: '쉬운 문법', value: 'EASY' },
  { key: 'b', label: '보통', content: '일반적인 문법', value: 'NORMAL' },
  { key: 'c', label: '어렵게', content: '어려운 문법', value: 'HARD' },
] as const;

// value를 서버에 맞춰서 만들기
export const TOEIC_LEVEL_OPTIONS = [
  { key: 'toeic950', label: '', content: '900점대', value: 950 },
  { key: 'toeic850', label: '', content: '800점대', value: 850 },
  { key: 'toeic750', label: '', content: '700점대', value: 750 },
  { key: 'toeic650', label: '', content: '600점대', value: 650 },
  { key: 'toeic550', label: '', content: '500점대', value: 550 },
] as const;

export const JLPT_LEVEL_OPTIONS = [
  { key: 'jlpt1', label: '', content: 'N1', value: 1 },
  { key: 'jlpt2', label: '', content: 'N2', value: 2 },
  { key: 'jlpt3', label: '', content: 'N3', value: 3 },
  { key: 'jlpt4', label: '', content: 'N4', value: 4 },
  { key: 'jlpt5', label: '', content: 'N5', value: 5 },
] as const;

export const JAPANESE_TEST_VOCABULARY_BOOK_LEVEL_OPTIONS = [
  { key: 'jlpt5', label: 'N5', content: '기초 단어', value: 'JLPT5' },
  { key: 'jlpt4', label: 'N4', content: '초급 단어', value: 'JLPT4' },
  { key: 'jlpt3', label: 'N3', content: '초중급 단어', value: 'JLPT3' },
  { key: 'jlpt2', label: 'N2', content: '중급 단어', value: 'JLPT2' },
  { key: 'jlpt1', label: 'N1', content: '고급 단어', value: 'JLPT1' },
] as const;

export const ENGLISH_TEST_VOCABULARY_BOOK_LEVEL_OPTIONS = [
  { key: 'toeic550', label: 'TOEIC 550', content: '기초 단어', value: 'TOEIC550' },
  { key: 'toeic650', label: 'TOEIC 650', content: '초급 단어', value: 'TOEIC650' },
  { key: 'toeic750', label: 'TOEIC 750', content: '초중급 단어', value: 'TOEIC750' },
  { key: 'toeic850', label: 'TOEIC 850', content: '중급 단어', value: 'TOEIC850' },
  { key: 'toeic950', label: 'TOEIC 950', content: '고급 단어', value: 'TOEIC950' },
] as const;

export const STUDY_VOCABULARY_BOOK_LEVEL_OPTIONS = [
  { key: 'easiest', label: '가볍게', content: '매우 쉬운 단어', value: 'EASIEST' },
  { key: 'easy', label: '쉽게', content: '쉬운 단어', value: 'EASY' },
  { key: 'normal', label: '보통', content: '일반적인 단어', value: 'NORMAL' },
  { key: 'hard', label: '어렵게', content: '어려운 단어', value: 'HARD' },
  { key: 'hardest', label: '독하게', content: '매우 어려운 단어', value: 'HARDEST' },
] as const;
